import React from 'react'
import html from '../assets/html.png';
import css from '../assets/css.png';
import javascript from '../assets/javascript.png';
import reactImage from '../assets/react.png';
// import github from '../assets/github.png';
import mongodb from '../assets/mongodb.png';
import express from '../assets/express.png';
import node from '../assets/node.png';
import javaImage from '../assets/java.png';
import pythonImage from '../assets/python.png';

const Technologies = () => {
    const tech = [
        {
            id:1,
            src:html,
            title:'HTML',
            style:'shadow-orange-500'
        },
        {
            id:2,
            src:css,
            title:'CSS',
            style:'shadow-blue-500'
        },
        {
            id:3,
            src:javascript,
            title:'Javascript',
            style:'shadow-yellow-500'
        },
        {
            id:4,
            src:reactImage,
            title:'React',
            style:'shadow-blue-500'
        },
        {
            id:5,
            src:mongodb,
            title:'MongoDB',
            style:'shadow-green-500'
        },
        {
            id:6,
            src:express,
            title:'Express',
            style:'shadow-gray-500'
        },
        {
            id:7,
            src:node,
            title:'Node',
            style:'shadow-green-500'
        },
        {
            id:8,
            src:javaImage,
            title:'Java',
            style:'shadow-orange-500'
        },
        {
            id:9,
            src:pythonImage,
            title:'Python',
            style:'shadow-blue-500'
        },
        
    ]
  return (
    <div name='Technologies' className='bg-gradient-to-b from-gray-800 to-black w-full h-full'>
        <div className='max-w-screen-lg mx-auto p-4 flex flex-col justify-center w-full h-full text-white'>
            <div>
                <p className='text-4xl font-bold border-b-4 border-gray-500 p-2 inline'>Technologies</p>
                <p className='py-6'>These are the Technologies.. which I am familiar with! </p>
            </div>
            <div className='w-full grid grid-cols-2 sm:grid-cols-3 gap-8 text-center py-8 px-12 sm:px-0'>
                {
                    tech.map(({id,src,title,style})=>(
                        <div key={id} className={`shadow-md hover:scale-105 duration-500 py-2 rounded-lg ${style}`}>
                    <img src={src} alt="" className='w-20 mx-auto' />
                    <p className='mt-4'>{title}</p>
                </div>

                    ))
                }
            </div>

        </div>
    </div>
  )
}

export default Technologies